import isEmpty from 'lodash-es/isEmpty';
import React from 'react';
import { Dashboard } from '@components/common';
import { HeadContent, Pagination, usePagination } from '@fourthwall/components';
import { createUseOrdersQueryParams, useOrdersQuery } from '@hooks';
import { useSearchQuery } from '@modules/Dashboard/hooks/useSearchQuery';
import { OrdersData } from './components/OrdersData/OrdersData';
import { OrdersEmptyStateWithRecommendations } from './components/OrdersEmptyStateWithRecommendations/OrdersEmptyStateWithRecommendations';
import { OrdersEmptyState } from './components/OrdersEmpyState/OrdersEmptyState';
import { SIZE } from './consts';
import { useFilterContributions } from './hooks/useFilterContributions';
export const OrdersList = () => {
    const { searchQuery } = useSearchQuery();
    const [currentPage, setCurrentPage] = usePagination();
    const { filtersParams, hasFilterParams } = useFilterContributions();
    const { data, ordersQuery } = useOrdersQuery(createUseOrdersQueryParams({
        currentPage,
        size: SIZE,
        query: searchQuery,
        status: filtersParams?.status?.split(','),
        sales: filtersParams?.salesChannel?.split(','),
        types: filtersParams?.type?.split(','),
        filterOutGiveawayGifts: !searchQuery,
    }), { keepPreviousData: true });
    const hasFilters = searchQuery || hasFilterParams;
    const totalPages = data?.page.totalPages;
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Orders" }),
        !isEmpty(data?.orders) || ordersQuery.isFetching ? (React.createElement(React.Fragment, null,
            React.createElement(Dashboard.Section.Item, null,
                React.createElement(OrdersData, { data: data?.orders || [], isLoading: ordersQuery.isFetching })),
            totalPages && totalPages > 0 ? (React.createElement(Dashboard.Section.Item, null,
                React.createElement(Pagination, { pageCount: totalPages, currentPage: currentPage, onChange: setCurrentPage }))) : null)) : (React.createElement(Dashboard.Section.Item, null, hasFilters ? React.createElement(OrdersEmptyState, null) : React.createElement(OrdersEmptyStateWithRecommendations, null)))));
};
